export const HOTFIX = 'HOTFIX';
export const RELEASE = 'RELEASE';
export const LAUNCH = 'LAUNCH';
export const DESTROY = 'DESTROY';
export const CUSTOM = 'CUSTOM';
export const UNLOCK_STATE = 'UNLOCK_STATE';
export const PLAN = 'PLAN';
export const APPLY_PLAN = 'APPLY_PLAN';
export const SCALE_UP = 'SCALE_UP';
export const SCALE_DOWN = 'SCALE_DOWN';
